import { Routes } from '@angular/router';
import { authGuard } from "../../_shared/helpers";
import { JobsComponent } from "./jobs/jobs.component";
import { JobDetailsComponent } from "./job-details/job-details.component";
import { JobUpdateComponent } from "./job-update/job-update.component";
import { JobDetailsOrdersComponent } from "./job-details/job-details-orders/job-details-orders.component";

export const JOB_ROUTES: Routes = [
  {
    path: 'projects',
    pathMatch: 'full',
    redirectTo: 'jobs/overview',
  },
  {
    path: 'jobs/overview',
    component: JobsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'job/details/:prid/:jobid',
    component: JobDetailsComponent,
    children: [
      {
        path: 'orders',
        component: JobDetailsOrdersComponent,
        canActivate: [authGuard]
      },
    {
      path: 'job/update/:prid/:jobid',
      component: JobUpdateComponent,
      canActivate: [authGuard]
    }
  ],
    canActivate: [authGuard]
  },
  {
    path: 'job/update/:prid/:jobid',
    component: JobUpdateComponent,
    canActivate: [authGuard]
  },
];
